function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  id: "background",
  width: 349.7,
  height: 279.41
});

var SvgScreenTitleCard = function SvgScreenTitleCard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "screen-title-card",
    viewBox: "0 0 349.7 279.41",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    id: "stars"
  }, React.createElement("polygon", {
    className: "star star00",
    points: "26.33 242.28 29.08 247.84 35.22 248.73 30.78 253.06 31.83 259.18 26.33 256.29 20.84 259.18 21.89 253.06 17.45 248.73 23.59 247.84 26.33 242.28",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("polygon", {
    className: "star star01",
    points: "322.96 242.28 325.71 247.84 331.85 248.73 327.4 253.06 328.45 259.18 322.96 256.29 317.47 259.18 318.52 253.06 314.07 248.73 320.21 247.84 322.96 242.28",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("polygon", {
    className: "star star02",
    points: "174.65 242.28 177.39 247.84 183.53 248.73 179.09 253.06 180.14 259.18 174.65 256.29 169.16 259.18 170.2 253.06 165.76 248.73 171.9 247.84 174.65 242.28",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("polygon", {
    className: "star star03",
    points: "100.49 242.28 103.24 247.84 109.38 248.73 104.93 253.06 105.98 259.18 100.49 256.29 95 259.18 96.05 253.06 91.6 248.73 97.74 247.84 100.49 242.28",
    style: {
      fill: "#329cfc"
    }
  }), React.createElement("polygon", {
    className: "star star04",
    points: "248.8 242.28 251.55 247.84 257.69 248.73 253.25 253.06 254.3 259.18 248.8 256.29 243.31 259.18 244.36 253.06 239.92 248.73 246.06 247.84 248.8 242.28",
    style: {
      fill: "#329cfc"
    }
  }), React.createElement("polygon", {
    className: "star star05",
    points: "26.33 21.23 29.08 26.8 35.22 27.69 30.78 32.02 31.83 38.13 26.33 35.25 20.84 38.13 21.89 32.02 17.45 27.69 23.59 26.8 26.33 21.23",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("polygon", {
    className: "star star06",
    points: "322.96 21.23 325.71 26.8 331.85 27.69 327.4 32.02 328.45 38.13 322.96 35.25 317.47 38.13 318.52 32.02 314.07 27.69 320.21 26.8 322.96 21.23",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("polygon", {
    className: "star star07",
    points: "174.65 21.23 177.39 26.8 183.53 27.69 179.09 32.02 180.14 38.13 174.65 35.25 169.16 38.13 170.2 32.02 165.76 27.69 171.9 26.8 174.65 21.23",
    style: {
      fill: "#c60e2d"
    }
  }), React.createElement("polygon", {
    className: "star star08",
    points: "100.49 21.23 103.24 26.8 109.38 27.69 104.93 32.02 105.98 38.13 100.49 35.25 95 38.13 96.05 32.02 91.6 27.69 97.74 26.8 100.49 21.23",
    style: {
      fill: "#329cfc"
    }
  }), React.createElement("polygon", {
    className: "star star09",
    points: "248.8 21.23 251.55 26.8 257.69 27.69 253.25 32.02 254.3 38.13 248.8 35.25 243.31 38.13 244.36 32.02 239.92 27.69 246.06 26.8 248.8 21.23",
    style: {
      fill: "#329cfc"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScreenTitleCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/screen-title-card.4252c4fa.svg";
export { ForwardRef as ReactComponent };